import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'event-current-status',
	template: `
			<div class="event-status__text">
				<div class="event-status__label">Aktueller Status:</div>
				<div class="event-status__name">{{lifecyclePhaseName}}</div>
			</div>`,
	styles: [require("./event-current-status.presentation.scss")],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class EventCurrentStatusComponent {
	@Input() lifecyclePhaseName
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/event-status/event-current-status/event-current-status.presentation.ts